export const parcelasvendaDigitada = [
  {
    key: 1,
    value: "1",
    text: "1 Parcela",
  },
  {
    key: 2,
    value: "2",
    text: "2 Parcelas",
  },
  {
    key: 3,
    value: "3",
    text: "3 Parcelas",
  },
  {
    key: 4,
    value: "4",
    text: "4 Parcelas",
  },
  {
    key: 5,
    value: "5",
    text: "5 Parcelas",
  },
  {
    key: 6,
    value: "6",
    text: "6 Parcelas",
  },
  {
    key: 7,
    value: "7",
    text: "7 Parcelas",
  },
  {
    key: 8,
    value: "8",
    text: "8 Parcelas",
  },
  {
    key: 9,
    value: "9",
    text: "9 Parcelas",
  },
  {
    key: 10,
    value: "10",
    text: "10 Parcelas",
  },
  {
    key: 11,
    value: "11",
    text: "11 Parcelas",
  },
  {
    key: 12,
    value: "12",
    text: "12 Parcelas",
  },
  {
    key: 13,
    value: "13",
    text: "13 Parcelas",
  },
  {
    key: 14,
    value: "14",
    text: "14 Parcelas",
  },
  {
    key: 15,
    value: "15",
    text: "15 Parcelas",
  },
  {
    key: 16,
    value: "16",
    text: "16 Parcelas",
  },
  {
    key: 17,
    value: "17",
    text: "17 Parcelas",
  },
  {
    key: 18,
    value: "18",
    text: "18 Parcelas",
  },
  {
    key: 19,
    value: "19",
    text: "19 Parcelas",
  },
  {
    key: 20,
    value: "20",
    text: "20 Parcelas",
  },
  {
    key: 21,
    value: "21",
    text: "21 Parcelas",
  },
];
